import { parseError as a } from './contact-channels81.js';

function o(t){if(typeof t=="function")try{const r=t();return r instanceof Promise?o(r):{data:r}}catch(r){return {error:a(r)}}return t.then(r=>({data:r})).catch(r=>({error:a(r)}))}

export { o as attempt };
//# sourceMappingURL=contact-channels49.js.map
